export default __webpack_public_path__ + "static/media/psychosis_xmas.d75e9f60.png";